import { DatePicker } from 'components/ui/DatePicker/DatePicker';
import type { FieldInterface } from '../Field';

type DatepickerFieldProps = {
  field: FieldInterface;
  handleChange: (name: string, value?: string) => void;
  handleBlur: (name: string) => void;
};

const DatepickerField = ({
  field,
  handleBlur,
  handleChange,
}: DatepickerFieldProps) => {
  const {
    defaultValue,
    error,
    help,
    label,
    id,
    readOnly,
    required,
    placeholder,
  } = field;

  return (
    <DatePicker
      dateFormat={placeholder || undefined}
      error={error}
      hint={help}
      id={id}
      label={label}
      name={id}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      required={required}
      value={defaultValue}
    />
  );
};

export { DatepickerField };
